import { MockFactory } from '@tino-frontend/mocks'
import {
  BillInvoiceInstallmentsMopStatus,
  InstallmentStatus,
  MerchantGetInvoiceResponse,
} from '@types'
import { lineItemInstallment } from '@fixtures/apis/bill/line-item/installment'
import { lineItemInstallmentEdited } from '@fixtures/apis/bill/line-item/installment-edited'
import { lineItemInstallmentCanceled } from '@fixtures/apis/bill/line-item/installment-canceled'
import { lineItemInstallmentReimbursed } from '@fixtures/apis/bill/line-item/installment-reimbursed'

const installment1 = lineItemInstallment.build({
  ...lineItemInstallment.source,
  amount_cents: 66666,
  metadata: {
    ...lineItemInstallment.source.metadata,
    installment_id: 'invoice_installments_id_1',
  },
})

const installment2Edit = lineItemInstallmentEdited.build({
  ...lineItemInstallmentEdited.source,
  amount_cents: 77777,
  metadata: {
    ...lineItemInstallmentEdited.source.metadata,
    installment_id: 'invoice_installments_id_2',
  },
})

const installment3Canceled = lineItemInstallmentCanceled.build(
  {
    ...lineItemInstallmentCanceled.source,
    amount_cents: 88888,
    metadata: {
      ...lineItemInstallmentCanceled.source.metadata,
      installment_id: 'invoice_installments_id_3',
    },
  },
  { mergeArray: false }
)

const installment4Reimbursed = lineItemInstallmentReimbursed.build(
  {
    ...lineItemInstallmentReimbursed.source,
    amount_cents: 99999,
    metadata: {
      ...lineItemInstallmentReimbursed.source.metadata,
      installment_id: 'invoice_installments_id_4',
    },
  },
  { mergeArray: false }
)

export const listAllStatusMock = new MockFactory<MerchantGetInvoiceResponse>({
  invoice: {
    amount_cents: 200000,
    original_amount_cents: 199800,
    merchant_service_fee_amount_cents: 200,
    buyer_company_id: 'buyer_company_id_1',
    buyer_name: 'Buyer Company Ltda.',
    created_at: '2021-03-31T11:45:25.126666Z',
    deal_conditions: [10, 30, 60],
    description: 'Test 2',
    due_date: '2021-04-10T00:00:00Z',
    id: 'invoice_id_1',
    installments: 3,
    invoice_installments: [
      {
        transaction_id: 'transaction_id',
        amount_cents: 66666,
        buyer_conciliated_amount: 66661,
        buyer_conciliation_status: InstallmentStatus.FullySettled,
        id: 'invoice_installments_id_1',
        line_code: '34191.09107 52014.087309 71444.640008 1 93930000001200',
        mop_status: BillInvoiceInstallmentsMopStatus.Paid,
        settlement_date: '2023-06-29T00:00:00Z',
        status: InstallmentStatus.Settled,
        url: 'https://a1.com',
      },
      {
        transaction_id: 'transaction_id',
        amount_cents: 77777,
        buyer_conciliated_amount: 77771,
        buyer_conciliation_status: InstallmentStatus.FullySettled,
        id: 'invoice_installments_id_2',
        line_code: '34191.09107 52014.087309 71444.640008 1 93930000001201',
        mop_status: BillInvoiceInstallmentsMopStatus.Paid,
        settlement_date: '2023-06-29T00:00:00Z',
        status: InstallmentStatus.Settled,
        url: 'https://a2.com',
      },
      {
        transaction_id: 'transaction_id',
        amount_cents: 88888,
        buyer_conciliated_amount: 88881,
        buyer_conciliation_status: InstallmentStatus.FullySettled,
        id: 'invoice_installments_id_3',
        line_code: '34191.09107 52014.087309 71444.640008 1 93930000001203',
        mop_status: BillInvoiceInstallmentsMopStatus.Paid,
        settlement_date: '2023-06-30T00:00:00Z',
        status: InstallmentStatus.Settled,
        url: 'https://a3.com',
      },
      {
        transaction_id: 'transaction_id',
        amount_cents: 99999,
        buyer_conciliated_amount: 99991,
        buyer_conciliation_status: InstallmentStatus.Canceled,
        id: 'invoice_installments_id_4',
        line_code: '34191.09107 52014.087309 71444.640008 1 93930000001203',
        mop_status: BillInvoiceInstallmentsMopStatus.Canceled,
        settlement_date: '2023-06-30T00:00:00Z',
        status: InstallmentStatus.Canceled,
        url: 'https://a4.com',
      },
    ],
    seller_company_id: 'seller_company_id_1',
    seller_name: 'Marco Polo Ltda.',
    short_id: 'short_id_1',
    external_id: 'external_id_1',
    status: 'approved',
  },
  line_items: [
    installment1,
    installment2Edit,
    installment3Canceled,
    installment4Reimbursed,
  ],
  nfe_download_token: 'nfe_download_token',
})
